import React, { useState, createContext, useContext } from 'react';
export type ProfileRole = 'cm' | 'man';
export interface PublicProfile {
  businessName: string;
  tagline: string;
  coverUrl: string;
  logoUrl: string;
  description: string;
  services: string[];
  zones: string[];
  phone: string;
  email: string;
  website: string;
  ctaLabel: string;
}
const DEFAULTS: Record<ProfileRole, PublicProfile> = {
  cm: {
    businessName: 'CleanMilano Servizi',
    tagline: 'Pulizie professionali per affitti brevi a Milano',
    coverUrl: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&q=80&w=1200',
    logoUrl: '',
    description: 'Gestiamo le pulizie dei tuoi appartamenti in affitto breve con un team affidabile e standard alberghieri. Turnover rapidi, controllo qualità foto prima/dopo e cura dei dettagli su ogni intervento.',
    services: ['Pulizia turnover', 'Deep cleaning', 'Cambio biancheria', 'Controllo qualità foto', 'Rifornimento amenities'],
    zones: ['Navigli', 'Isola', 'Centro', 'Porta Romana', 'Tortona'],
    phone: '+39 02 1234 5678',
    email: 'info@cleanmilano.it',
    website: 'www.cleanmilano.it',
    ctaLabel: 'Richiedi un preventivo'
  },
  man: {
    businessName: 'Rossi Manutenzioni',
    tagline: 'Idraulica, elettrica e piccoli interventi in giornata',
    coverUrl: 'https://images.unsplash.com/photo-1504148455328-c376907d081c?auto=format&fit=crop&q=80&w=1200',
    logoUrl: '',
    description: 'Tecnico manutentore con oltre 10 anni di esperienza al servizio di host e property manager. Interventi rapidi su impianti idraulici ed elettrici, riparazioni e manutenzione ordinaria.',
    services: ['Idraulica', 'Impianti elettrici', 'Piccole riparazioni', 'Manutenzione caldaie', 'Pronto intervento'],
    zones: ['Milano Sud', 'Navigli', 'Porta Romana', 'Bocconi'],
    phone: '+39 333 987 6543',
    email: 'rossi.manutenzioni@gmail.com',
    website: '',
    ctaLabel: 'Contattaci'
  }
};
interface PublicProfileContextValue {
  profiles: Record<ProfileRole, PublicProfile>;
  updateProfile: (role: ProfileRole, patch: Partial<PublicProfile>) => void;
}
const PublicProfileContext = createContext<PublicProfileContextValue | null>(null);
export function PublicProfileProvider({
  children
}: {
  children: ReactNode;
}) {
  const [profiles, setProfiles] = useState<Record<ProfileRole, PublicProfile>>(DEFAULTS);
  const updateProfile = (role: ProfileRole, patch: Partial<PublicProfile>) => {
    setProfiles(prev => ({
      ...prev,
      [role]: {
        ...prev[role],
        ...patch
      }
    }));
  };
  return <PublicProfileContext.Provider value={{
    profiles,
    updateProfile
  }} data-id="element-1185">
      {children}
    </PublicProfileContext.Provider>;
}
export function usePublicProfile(role: ProfileRole) {
  const ctx = useContext(PublicProfileContext);
  if (!ctx) {
    throw new Error('usePublicProfile must be used within a PublicProfileProvider');
  }
  return {
    profile: ctx.profiles[role],
    update: (patch: Partial<PublicProfile>) => ctx.updateProfile(role, patch)
  };
}